import appConfig from '../../../config/appConfig';

var purchaseSuggestionConfig = {
  apiUrl: appConfig.apiUrl + 'purchasesuggestions/',
  budgetApiUrl: appConfig.apiUrl + 'budgets/'
};

export default purchaseSuggestionConfig;



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/config/purchaseSuggestionConfig.js